module.exports = __webpack_public_path__ + "static/img/bmp.0c70c408.svg";